module.exports = __webpack_public_path__ + "asset/pdf--03986b.png";